import { useAppSelector } from 'store'
import { useCallCore } from 'App/components'

export const ExternalMeetingRoom = () => {
  const session = useAppSelector((state) => state.meetings.session)

  const { render } = useCallCore({
    type: 'meeting',
    avatarURL: '',
    accountData: null,
    jwt: session?.token,
    serverUrl: session?.serverUrl,
    joinUrl: session?.joinUrl,
    isVideoCall: false,
    isMicOn: true
  })

  if (!session) {
    return null
  }

  return render()
}
